import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../services/AuthContext'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireAdmin?: boolean
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin = false }) => {
  const { user, loading } = useAuth()
  const location = useLocation()

  // If we're loading, show loading state
  if (loading) {
    return (
      <div className="container" style={{ padding: '2rem', textAlign: 'center' }}>
        <div>Loading...</div>
      </div>
    )
  }

  // If no user after loading is complete, redirect to login
  if (!user) {
    // Preserve query parameters and add redirect path when redirecting to login
    const searchParams = new URLSearchParams(location.search)
    searchParams.set('redirect', location.pathname) // Store original path
    const redirectTo = `/login?${searchParams.toString()}`
    return <Navigate to={redirectTo} replace />
  }

  if (requireAdmin && user.role !== 'admin') {
    return <Navigate to="/account" replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
